import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { NotificationProvider } from './contexts/NotificationContext';
import { OperatorProvider } from './contexts/OperatorContext';
import { Router } from './Router';
import { UserProvider } from './contexts/UserContext';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './assets/css/portal.css';
import { AppViewProvider } from './contexts/AppViewContext';

const queryClient = new QueryClient();

ReactDOM.render(
  <MuiPickersUtilsProvider utils={MomentUtils}>
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
        <UserProvider>
          <AppViewProvider>
            <OperatorProvider>
              <Router />
            </OperatorProvider>
          </AppViewProvider>
        </UserProvider>
      </NotificationProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </MuiPickersUtilsProvider>,
  document.getElementById('root')
);
